import { getLangByStorage } from '@/utils/local_storage';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import langZh from '@/lang/zh';
import langEn from '@/lang/en';

Vue.use(VueI18n);

const messages = {
  en: {
    ...langEn
  },
  zh: {
    ...langZh
  }
};

const getLocale = () => {
  let lang = 'en';
  // try {
  //   if (getLangByStorage()) {
  //     lang = getLangByStorage();
  //   } else if (navigator.language) {
  //     if (/^en\b/.test(navigator.language)) {
  //       lang = 'en';
  //     } else if (/^zh\b/.test(navigator.language)) {
  //       lang = 'zh';
  //     } else {
  //       lang = 'en';
  //     }
  //   }
  // } catch (err) {
  //   console.error('lang:err', err);
  // }
  return lang;
};

const i18n = new VueI18n({
  locale: getLocale(),
  messages
});

export default i18n;
